"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const selectors_1 = require("@/store/ducks/products/selectors");
const products_1 = require("@/store/ducks/products");
const listProductsUseCase_1 = require("@/useCases/products/listProductsUseCase");
const index_view_1 = __importDefault(require("./index.view"));
function ProductsTable() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useHistory)();
    (0, react_1.useEffect)(() => {
        (0, listProductsUseCase_1.listProducts)()(dispatch);
    }, []);
    const productRows = (0, react_redux_1.useSelector)(selectors_1.productTableRowsSelector);
    const isLoading = (0, react_redux_1.useSelector)(selectors_1.isProductListLoadingSelector);
    const onShowDeleteAlert = react_1.default.useCallback((product, rowIndex) => {
        dispatch((0, products_1.openDeleteProductModal)({
            productToBeDeleted: product,
            rowIndexToBeDeleted: rowIndex,
        }));
    }, [dispatch, products_1.openDeleteProductModal]);
    const onNavigateToEdition = (productId) => {
        history.push(`/products/${productId}`);
    };
    return (react_1.default.createElement(index_view_1.default, { onNavigateToEdition: onNavigateToEdition, productRows: productRows, isLoading: isLoading, onShowDeleteAlert: onShowDeleteAlert }));
}
exports.default = ProductsTable;
